import { status_consumption_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateStatusConsumptionEnum = (enumValue: status_consumption_enum) => {
  switch (enumValue) {
    case status_consumption_enum.ACTIVE:
      return <Trans i18nKey="Enum_StatusConsumptionEnum-ACTIVE" />;
    case status_consumption_enum.ARCHIVED:
      return <Trans i18nKey="Enum_StatusConsumptionEnum-ARCHIVED" />;
    case status_consumption_enum.DUPLICATED:
      return <Trans i18nKey="Enum_StatusConsumptionEnum-DUPLICATED" />;
    case status_consumption_enum.FAILED:
      return <Trans i18nKey="Enum_StatusConsumptionEnum-FAILED" />;
    case status_consumption_enum.INACTIVE:
      return <Trans i18nKey="Enum_StatusConsumptionEnum-INACTIVE" />;
    case status_consumption_enum.NEEDS_REVIEW:
      return <Trans i18nKey="Enum_StatusConsumptionEnum-NEEDS_REVIEW" />;
    case status_consumption_enum.PROCESSING:
      return <Trans i18nKey="Enum_StatusConsumptionEnum-PROCESSING" />;
  }
};

export const translateStatusConsumptionEnum_dynamic = (enumValue: status_consumption_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case status_consumption_enum.ACTIVE:
      return t('Enum_StatusConsumptionEnum-ACTIVE');
    case status_consumption_enum.ARCHIVED:
      return t('Enum_StatusConsumptionEnum-ARCHIVED');
    case status_consumption_enum.DUPLICATED:
      return t('Enum_StatusConsumptionEnum-DUPLICATED');
    case status_consumption_enum.FAILED:
      return t('Enum_StatusConsumptionEnum-FAILED');
    case status_consumption_enum.INACTIVE:
      return t('Enum_StatusConsumptionEnum-INACTIVE');
    case status_consumption_enum.NEEDS_REVIEW:
      return t('Enum_StatusConsumptionEnum-NEEDS_REVIEW');
    case status_consumption_enum.PROCESSING:
      return t('Enum_StatusConsumptionEnum-PROCESSING');
  }
};
